<template>
	<div>
		<square-box
			:focused="selected"
			:checked="completed"
			:name="job.name"
			@onEditClick="$emit('editionClick', job)"
			@onDeleteClick="onDeleteClick"
		></square-box>
		<p-confirm-dialog ref="confirmDialog" />
	</div>
</template>

<script>
import PConfirmDialog from '@/modules/shared/components/ui/p-confirm-dialog';
import SquareBox from '../../../../../../shared/components/content/SquareBox';

export default {
	name: 'guideline-model-job-item',
	components: { SquareBox, PConfirmDialog },
	props: ['job', 'selected', 'completed'],
	methods: {
		onDeleteClick() {
			this.$refs.confirmDialog.showConfirm({
				onOk: () => {
					this.$emit('deleteClick', this.job);
				},
				title: `¿Seguro que desea eliminar "${this.job.name}" de la lista?`,
			});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-list/guideline-model-job-item.vue